import { useCallback, useState } from "react";
import client from "../client";
import handleApiError from "../../hooks/handleApiError";
import moment from "moment";

export default function useFetchCalendar() {
  const [loading, setLoading] = useState(false);
  const [calendar, setCalendar] = useState(null);
  const [holidays, setHolidays] = useState([]);

  const request = useCallback(async (_state, _session, _term) => {
    setCalendar(null);
    setHolidays([]);

    try {
      setLoading(true);

      const res = await client.get(`/calendar/state/${_state}`, {
        params: {
          session: _session,
          term: _term,
        },
      });

      if (res.data?.data?.length) {
        setCalendar(res.data?.data?.[0]);
        formatCalendarDates(res.data?.data?.[0]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  function formatCalendarDates(_calendar) {
    if (!_calendar) return;

    let resumptionDate = moment(_calendar?.resumptionDate).toDate();
    let resumption = {
      id: "resumption",
      title: "Resumption",
      start: resumptionDate,
      end: resumptionDate,
      color: "#0AD0AA",
      allDay: true,
    };

    let closingDate = moment(_calendar?.closingDate).toDate();
    let close = {
      id: "close",
      title: "Close",
      start: closingDate,
      end: closingDate,
      color: "#F66257",
      allDay: true,
    };

    let vacationStartDate = moment(_calendar?.vacationStartDate).toDate();
    let vacationEndDate = moment(_calendar?.vacationEndDate).toDate();
    let vacation = {
      id: "vacation",
      title: "Vacation",
      start: vacationStartDate,
      end: vacationEndDate,
      color: "#F7C94D",
      allDay: true,
    };

    setHolidays([vacation, resumption, close]);

    return null;
  }

  return { calendar, holidays, loading, request };
}
